// extracted by mini-css-extract-plugin
export var boldText = "_6n-4";
export var checkboxContainer = "_6n-6";
export var closeIcon = "_6n-i";
export var container = "_6n-0";
export var drawer = "_6n-8";
export var drawerContent = "_6n-9";
export var extraSmallText = "_6n-5";
export var fulfillmentGroupTable = "_6n-e";
export var largeText = "_6n-3";
export var loadingSpinnerContainer = "_6n-j";
export var mediumText = "_6n-2";
export var narrow = "_6n-f";
export var notificationLink = "_6n-l";
export var packageCheckIconContainer = "_6n-7";
export var slideoutHeaderActions = "_6n-g";
export var slideoutHeaderActionsShifted = "_6n-h";
export var slideoutHeaderContainer = "_6n-a";
export var slideoutModal = "_6n-c";
export var stickyHeaderWrapper = "_6n-b";
export var table = "_6n-k";
export var tableContainer = "_6n-d";
export var tertiaryText = "_6n-1";